import { FeatureGrid } from "@/components/FeatureGrid";
import { FeatureModal } from "@/components/FeatureModal";
import { ContactModal } from "@/components/ContactModal";
import { HeroSection } from "@/components/HeroSection";
import { MediaLibrarySection } from "@/components/MediaLibrarySection";
import { MediaLibraryModal } from "@/components/MediaLibraryModal";
import { SiteFooter } from "@/components/SiteFooter";

export const ExplordioPage = ({ onFeatureOpen, onContactOpen, onLibraryOpen }) => (
  <main className="explordio-page" data-testid="explordio-page">
    <HeroSection onContactOpen={onContactOpen} />
    <FeatureGrid onFeatureOpen={onFeatureOpen} />
    <MediaLibrarySection onLibraryOpen={onLibraryOpen} />
    <SiteFooter />
  </main>
);

ExplordioPage.FeatureModal = FeatureModal;
ExplordioPage.ContactModal = ContactModal;
ExplordioPage.MediaLibraryModal = MediaLibraryModal;